/* Cimafer · Orçamento — núcleo compartilhado (F1, tema dev)
 *
 * Estado local em localStorage 'cima:orcamento' = [{h: handle, v: variantId, q: qtd}].
 * Mesmo padrão da wishlist ('cima:wishlist'), mas COM quantidade — favoritos é
 * "quero lembrar", orçamento é "quanto custa a obra".
 *
 * Exporta window.CimaOrcamento p/ a página (sections/cima-orcamento.liquid).
 * Cuida também do contador do header e dos botões [data-cima-orc] em card/PDP.
 *
 * Compartilhamento (F1): a lista vai na própria URL (?o=handle:qtd:variante,…),
 * sem backend. O link curto via Worker fica p/ a F2 — a página já aceita os dois
 * formatos, então a F2 não exige retrabalho aqui.
 */
(() => {
  const KEY = 'cima:orcamento';
  const PEND_KEY = 'cima:orcamento:pendente'; // intenção de clique atravessando o login
  const EV = 'cima:orcamento:change';

  const clampQty = (n) => Math.min(9999, Math.max(1, parseInt(n, 10) || 1));

  // ── Orçamento NA CONTA do cliente (14/out, pedido do dono) ──────────────
  // A lista continua no localStorage (rápida, funciona offline), mas para quem está
  // LOGADO ela é espelhada no Worker cimafer-orcamento (D1, 1 linha por customer.id) e
  // volta em qualquer aparelho. Autenticação: o Liquid do tema só entrega
  // CIMA_CLIENTE.tok (HMAC do customer.id) para quem está logado; o Worker confere.
  //   • "sujo" = mudança local que a conta ainda não recebeu; "ts" = carimbo do SERVIDOR
  //     da última sincronização (nunca comparamos com o relógio do navegador).
  //   • Ao abrir a página: conta mudou e local limpo → adota a da conta; local sujo →
  //     junta (maior quantidade vence) e envia; lista local de ANTES do recurso → junta e envia.
  //   • Lista local de OUTRA conta (computador compartilhado) é descartada, nunca enviada.
  //   • Falha de rede nunca apaga nada: segue só local e tenta de novo na próxima.
  const K_SUJO = 'cima:orcamento:sujo';
  const K_TS = 'cima:orcamento:ts';
  const K_UID = 'cima:orcamento:uid';
  const lsGet = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
  const lsSet = (k, v) => { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch {} };
  const conta = () => {
    const c = window.CIMA_CLIENTE;
    return c && c.logado && c.id && c.tok ? c : null;
  };
  let timerPush = null;
  let emPuxada = false;
  let falhasPush = 0;

  const chamaConta = async (rota, extra) => {
    const c = conta();
    if (!c) return null;
    try {
      const corpo = JSON.stringify({ cid: String(c.id), tok: c.tok, ...extra });
      const r = await fetch(API + '/api/conta/' + rota, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: corpo,
        keepalive: corpo.length < 50000,   // keepalive tem teto de 64 KiB por requisição
      });
      if (r.status === 409) return { conflito: true, ...(await r.json()) };
      return r.ok ? await r.json() : null;
    } catch { return null; }
  };

  const empurra = async (interno, tent) => {
    clearTimeout(timerPush);
    const marca = lsGet(K_SUJO);
    if (!conta() || !marca) return null;
    // Durante a leitura inicial da conta não enviamos: ela pode trazer mudanças de outro
    // aparelho que precisam ser JUNTADAS antes (puxa() chama empurra(true) ao terminar).
    if (emPuxada && !interno) { timerPush = setTimeout(() => empurra(), 400); return null; }
    const r = await chamaConta('salvar', { itens: read(), obs: lerObs(), base: Number(lsGet(K_TS) || 0) });
    if (r && r.conflito) {
      // A conta mudou desde a última sincronização (outro aparelho): junta e tenta de novo.
      if ((tent || 0) >= 2) return null;
      aplicaLocal(uniao(read(), r.itens), lerObs() || r.obs || '');
      lsSet(K_TS, String(r.ts || 0));
      return empurra(true, (tent || 0) + 1);
    }
    if (r && r.ts) {
      falhasPush = 0;
      if (r.ts > Number(lsGet(K_TS) || 0)) lsSet(K_TS, String(r.ts));   // o carimbo nunca anda para trás
      if (lsGet(K_SUJO) === marca) lsSet(K_SUJO, null);   // mudou durante o envio (nesta ou noutra aba)? segue sujo
      return r;
    }
    // falhou: tenta de novo até 3x (e de novo na próxima página). Fica "sujo", nada se perde.
    if (++falhasPush <= 3) timerPush = setTimeout(() => empurra(), 15000);
    return null;
  };
  const agendaPush = () => { clearTimeout(timerPush); timerPush = setTimeout(empurra, 800); };
  // "sujo" guarda um carimbo único (não '1'): quem terminou de enviar só limpa se NINGUÉM
  // (outra aba) marcou mudança nova depois que o envio começou.
  const novaMarca = () => Date.now() + '.' + Math.random().toString(36).slice(2, 8);
  const marcaSujo = () => { if (!conta()) return; lsSet(K_SUJO, novaMarca()); agendaPush(); };

  const uniao = (a, b) => {
    const m = new Map();
    [...(a || []), ...(b || [])].forEach((i) => {
      const x = m.get(i.h);
      if (!x) m.set(i.h, { h: i.h, v: i.v || '', q: clampQty(i.q) });
      else { x.q = Math.max(x.q, clampQty(i.q)); if (!x.v && i.v) x.v = i.v; }
    });
    return [...m.values()];
  };
  const aplicaLocal = (itens, obs) => {      // grava SEM marcar sujo (veio da conta)
    const lista = (itens || []).filter((x) => x && x.h)
      .map((x) => ({ h: String(x.h), v: x.v ? String(x.v) : '', q: clampQty(x.q) }));
    lsSet(KEY, JSON.stringify(lista));
    lsSet(KEY_OBS, String(obs || '').slice(0, MAX_OBS));
    document.dispatchEvent(new CustomEvent(EV, { detail: { origem: 'conta' } }));
  };

  // Troca de conta no mesmo aparelho: a lista local é da conta ANTERIOR. Roda de forma SÍNCRONA
  // antes de qualquer outra coisa (inclusive do item "escolhido antes do login"), senão esse item
  // entraria na lista errada e seria apagado depois.
  const isolaConta = () => {
    const c = conta();
    if (!c) return;
    const uid = lsGet(K_UID);
    if (uid && uid !== String(c.id)) {
      lsSet(KEY, '[]'); lsSet(KEY_OBS, ''); lsSet(K_SUJO, null); lsSet(K_TS, null);
      document.dispatchEvent(new CustomEvent(EV, { detail: { origem: 'conta' } }));
    }
    lsSet(K_UID, String(c.id));
  };

  const puxa = async () => {
    const c = conta();
    if (!c || emPuxada) return;
    emPuxada = true;
    try {
      isolaConta();
      const srv = await chamaConta('ler', {});
      if (!srv || srv.conflito) return;        // sem rede/erro: segue só local
      const conhecido = lsGet(K_TS);
      if (Number(srv.ts || 0) < Number(conhecido || 0)) return;   // leitura antiga (chegou depois de um envio nosso)
      const mudouNaConta = String(srv.ts || 0) !== String(conhecido || 0);
      const sujo = !!lsGet(K_SUJO);
      const legado = !conhecido && read().length > 0;   // lista de antes deste recurso
      if (!sujo && !legado) {
        if (mudouNaConta) { aplicaLocal(srv.itens, srv.obs); lsSet(K_TS, String(srv.ts || 0)); }
        return;
      }
      if (mudouNaConta && ((srv.itens || []).length || srv.obs)) {
        aplicaLocal(uniao(read(), srv.itens), lerObs() || srv.obs || '');
      }
      lsSet(K_TS, String(srv.ts || 0));         // base do envio: o que acabamos de ler
      if (!lsGet(K_SUJO)) lsSet(K_SUJO, novaMarca());
      await empurra(true);
    } finally { emPuxada = false; }
  };

  const read = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw
        .filter((x) => x && x.h)
        .map((x) => ({ h: String(x.h), v: x.v ? String(x.v) : '', q: clampQty(x.q) }));
    } catch {
      return [];
    }
  };

  const write = (list) => {
    // dedup por handle mantendo a última quantidade
    const seen = new Map();
    list.forEach((i) => seen.set(i.h, i));
    const out = [...seen.values()];
    try { localStorage.setItem(KEY, JSON.stringify(out)); } catch {}
    marcaSujo();
    document.dispatchEvent(new CustomEvent(EV));
    return out;
  };

  const has = (handle) => read().some((i) => i.h === String(handle));

  // ── Observação livre: o que o cliente não achou no catálogo ─────────────
  // Guardada à parte da lista (chave própria) porque não é um produto — mas
  // viaja junto no link compartilhado e sai na impressão.
  const KEY_OBS = 'cima:orcamento:obs';
  const MAX_OBS = 1200;
  const lerObs = () => { try { return localStorage.getItem(KEY_OBS) || ''; } catch { return ''; } };
  const salvarObs = (txt) => {
    try { localStorage.setItem(KEY_OBS, String(txt || '').slice(0, MAX_OBS)); } catch {}
    marcaSujo();
    document.dispatchEvent(new CustomEvent(EV));
  };

  const add = (handle, variantId, qty) => {
    const h = String(handle || '');
    if (!h) return read();
    const list = read();
    const found = list.find((i) => i.h === h);
    if (found) {
      found.q = clampQty(found.q + (parseInt(qty, 10) || 1));
      if (variantId) found.v = String(variantId);
    } else {
      list.push({ h, v: variantId ? String(variantId) : '', q: clampQty(qty) });
    }
    return write(list);
  };

  const remove = (handle) => write(read().filter((i) => i.h !== String(handle)));
  const setQty = (handle, qty) => {
    const list = read();
    const found = list.find((i) => i.h === String(handle));
    if (found) found.q = clampQty(qty);
    return write(list);
  };
  const clear = () => write([]);

  // ── Serialização p/ o link compartilhado ────────────────────────────────
  // handle:qtd:variante  ·  handles nunca contêm ":" nem ","
  const encode = (list) =>
    (list || read()).map((i) => [i.h, i.q, i.v].filter(Boolean).join(':')).join(',');

  const decode = (str) => {
    if (!str) return [];
    return String(str)
      .split(',')
      .map((chunk) => {
        const [h, q, v] = chunk.split(':');
        return h ? { h: h.trim(), q: clampQty(q), v: (v || '').trim() } : null;
      })
      .filter(Boolean);
  };

  const API = 'https://cimafer-orcamento.anderson-74e.workers.dev';
  const cacheLink = new Map();

  const montaUrl = (valor) => {
    const u = new URL('/pages/orcamento', location.origin);
    u.searchParams.set('o', valor);
    // ⚠️ Quem RECEBE o link não tem o cookie de preview: cai no tema publicado,
    // onde a página do orçamento ainda não existe, e vê uma página vazia. Então
    // enquanto não publicarmos, o link leva o tema junto. Depois de publicado,
    // CIMA_TEMA.publicado vira true e o link sai limpo sozinho.
    const tema = window.CIMA_TEMA;
    const pid = (tema && !tema.publicado && tema.id)
      || new URLSearchParams(location.search).get('preview_theme_id');
    if (pid) u.searchParams.set('preview_theme_id', pid);
    return u.toString();
  };

  /** Link curto (6 caracteres) gravado no Worker + D1.
   *  A lista inteira na URL passava de 900 caracteres e o WhatsApp entregava o
   *  link QUEBRADO — link comprido não é compartilhável de verdade. Se o worker
   *  falhar, cai no formato longo: melhor um link feio do que nenhum. */
  const shareUrl = async (list, obs) => {
    const itens = list || read();
    const texto = obs === undefined ? lerObs() : String(obs || '');
    // ⚠️ a observação entra na chave do cache: mudou o texto, link novo.
    const chave = encode(itens) + '|' + texto;
    if (cacheLink.has(chave)) return cacheLink.get(chave);

    let url;
    try {
      const r = await fetch(API + '/api/criar', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ itens, obs: texto }),
      });
      const j = await r.json();
      if (!j || !j.codigo) throw new Error('sem código');
      url = montaUrl(j.codigo);
    } catch {
      // Sem o worker sobra o formato longo — que NÃO carrega a observação.
      // Melhor um link sem o texto do que nenhum link.
      url = montaUrl(encode(itens));
    }
    cacheLink.set(chave, url);
    return url;
  };

  /** Um `?o=` sem ":" é código curto; com ":" é a lista antiga na própria URL.
   *  Os links já enviados continuam abrindo. */
  const ehCodigoCurto = (valor) => /^[0-9A-Za-z]{4,12}$/.test(String(valor || '')) && !String(valor).includes(':');

  const buscarPorCodigo = async (codigo) => {
    try {
      const r = await fetch(`${API}/api/${encodeURIComponent(codigo)}`);
      if (!r.ok) return null;
      const j = await r.json();
      if (!j || !Array.isArray(j.itens)) return null;
      return {
        itens: j.itens.map((i) => ({ h: String(i.h), v: i.v ? String(i.v) : '', q: clampQty(i.q) })),
        obs: j.obs || '',
        criado_em: j.criado_em || '',
      };
    } catch {
      return null;
    }
  };

  // ── Aviso curto (usado pelos botões e pela página do orçamento) ─────────
  /** Aviso curto. `acao` opcional vira um link dentro do aviso — é o que responde
   *  "e agora?" pra quem acabou de adicionar. Esse aviso é o feedback que SEMPRE
   *  aparece, inclusive em quem tem movimento reduzido no sistema (aí o voo não
   *  roda de propósito). */
  /** Esconder o aviso TEM que tirar as duas classes. Só `is-on` deixava
   *  `is-clicavel` para trás, e com ele o pointer-events:auto — um retângulo
   *  invisível no meio da tela comendo clique (o clique na foto do produto
   *  parava de abrir a PDP depois do 1º item adicionado). O CSS agora exige
   *  `.is-on.is-clicavel` como rede, mas a limpeza aqui é a correção de fato. */
  const esconde = (el) => { if (el) el.classList.remove('is-on', 'is-clicavel'); };

  const toast = (msg, acoes) => {
    if (!msg) return;
    let el = document.querySelector('.cima-orc-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cima-orc-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = '';
    const txt = document.createElement('p');
    txt.className = 'cima-orc-toast__txt';
    txt.textContent = msg;
    el.appendChild(txt);

    // `acoes` = uma ação ou uma lista. `{href}` navega; `{fecha:true}` só some
    // com o aviso — é o "continuar adicionando", que devolve a página ao cliente.
    const lista = !acoes ? [] : (Array.isArray(acoes) ? acoes : [acoes]);
    if (lista.length) {
      const caixa = document.createElement('div');
      caixa.className = 'cima-orc-toast__acoes';
      lista.forEach((a) => {
        if (!a || !a.texto) return;
        const b = document.createElement(a.href ? 'a' : 'button');
        if (a.href) b.href = a.href; else b.type = 'button';
        b.className = 'cima-orc-toast__acao' + (a.secundaria ? ' cima-orc-toast__acao--sec' : '');
        b.textContent = a.texto;
        if (a.fecha) b.addEventListener('click', () => { clearTimeout(el._t); esconde(el); });
        caixa.appendChild(b);
      });
      el.appendChild(caixa);
      el.classList.add('is-clicavel');
    } else {
      el.classList.remove('is-clicavel');
    }
    // O aviso fica CENTRALIZADO na tela (CSS) — no rodapé passava despercebido
    // e, no preview, a barra da Shopify chegava a cobri-lo.
    requestAnimationFrame(() => el.classList.add('is-on'));
    clearTimeout(el._t);
    el._t = setTimeout(() => esconde(el), lista.length ? 6000 : 3400);
  };

  const anima = (el, cls, ms) => {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth; // reinicia a animação se clicar em sequência
    el.classList.add(cls);
    setTimeout(() => el.classList.remove(cls), ms || 600);
  };

  const semMovimento = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** A foto do produto voa do card/PDP até o contador do header.
   *  Um pulso no botão não conta a HISTÓRIA (o cliente não descobre pra onde o
   *  item foi); o voo liga origem e destino, que é o que faz a ação ser notada.
   *
   *  Feito com a Web Animations API, não com transition: `element.animate()`
   *  começa do jeito que a gente pede, sem depender de o navegador ter calculado
   *  o estado inicial antes — que era a causa do voo sumir de forma intermitente.
   *  O arco é explícito: amostro uma curva de Bézier em 12 quadros.
   *
   *  `forcar` ignora o prefers-reduced-motion (usado por CimaOrcamento.testarVoo).
   */
  const DUR_VOO = 720;

  const voaParaOrcamento = (btn, forcar) => {
    if (!forcar && semMovimento()) return 0;
    if (typeof Element.prototype.animate !== 'function') return 0;

    const alvo = document.querySelector('.cima-header__orc .cima-header__fav-icon-wrap');
    if (!alvo) return 0;
    const destino = alvo.getBoundingClientRect();
    if (!destino.width || destino.bottom < 0) return 0; // header fora de vista

    const cartao = btn && btn.closest('.cima-card-produto');
    const foto = cartao
      ? cartao.querySelector('.cima-card-produto__img')
      : document.querySelector('.cima-pdp__main-img');

    // ⚠️ O botão estar visível NÃO garante que a foto esteja: em card alto, a
    // imagem já saiu pelo topo quando o CTA aparece (medido: foto em y = -82).
    // Nesse caso o voo começava fora da tela e o cliente só via o finalzinho.
    // Âncora = a foto se o centro dela estiver à vista; senão, o próprio botão.
    const centroVisivel = (r) => {
      if (!r || !r.width) return false;
      const cy2 = r.top + r.height / 2;
      return cy2 > 56 && cy2 < window.innerHeight - 8;
    };
    const fotoRect = foto && foto.getBoundingClientRect();
    const btnRect = btn && btn.getBoundingClientRect();
    const usouFoto = centroVisivel(fotoRect);
    const origem = usouFoto ? fotoRect : (centroVisivel(btnRect) ? btnRect : fotoRect);
    if (!origem || !origem.width) return 0;

    const lado = usouFoto ? Math.min(origem.width, 160) : 72;
    const ghost = document.createElement('div');
    ghost.className = 'cima-orc-voo';
    ghost.style.left = (origem.left + (origem.width - lado) / 2) + 'px';
    ghost.style.top = (origem.top + (origem.height - lado) / 2) + 'px';
    ghost.style.width = lado + 'px';
    ghost.style.height = lado + 'px';
    if (foto && foto.tagName === 'IMG') {
      const c = document.createElement('img');
      c.src = foto.currentSrc || foto.src;
      c.alt = '';
      ghost.appendChild(c);
    }
    document.body.appendChild(ghost);

    const dx = (destino.left + destino.width / 2) - (origem.left + origem.width / 2);
    const dy = (destino.top + destino.height / 2) - (origem.top + origem.height / 2);
    const fim = Math.max(0.1, 30 / lado);

    // Ponto de controle do arco: sobe primeiro, depois corre pro header — assim
    // o olho acompanha, em vez de ver o item "deslizar" na diagonal.
    // ⚠️ Uma Bézier quadrática fica SEMPRE dentro do triângulo P0-P1-P2. Como o
    // header está colado no topo, qualquer ponto "acima" jogava metade do voo
    // pra fora da tela (medido: y = -161). Mantendo P1 dentro da caixa
    // origem→destino, a curva inteira fica visível por construção.
    const cx = dx * 0.12;
    const cy = dy * 0.92;

    const quadros = [];
    const N = 12;
    for (let i = 0; i <= N; i++) {
      const t = i / N;
      const u = 1 - t;
      const x = 2 * u * t * cx + t * t * dx;
      const y = 2 * u * t * cy + t * t * dy;
      // sobe um tico antes de encolher: dá a leitura de "pegou o item"
      const s = t < 0.16 ? 1 + t * 0.5 : 1.08 + (fim - 1.08) * ((t - 0.16) / 0.84);
      quadros.push({
        transform: `translate(${x}px, ${y}px) scale(${s})`,
        opacity: t < 0.7 ? 1 : 1 - ((t - 0.7) / 0.3) * 0.45,
        offset: t,
      });
    }

    const anim = ghost.animate(quadros, { duration: DUR_VOO, easing: 'cubic-bezier(.42,0,.35,1)', fill: 'forwards' });
    anim.finished.catch(() => {}).finally(() => ghost.remove());
    setTimeout(() => ghost.remove(), DUR_VOO + 250); // rede de segurança
    return DUR_VOO;
  };

  window.CimaOrcamento = {
    KEY, EV, read, write, add, remove, setQty, clear, has,
    encode, decode, shareUrl, ehCodigoCurto, buscarPorCodigo, toast,
    lerObs, salvarObs, MAX_OBS,
    /** Orçamento na conta (ver bloco acima). */
    conta, puxa, empurra,
    /** Diagnóstico: dispara o voo IGNORANDO o "movimento reduzido" do sistema.
     *  Se testarVoo() anima e o clique normal não, a causa é a preferência de
     *  acessibilidade do computador — não o código. */
    testarVoo: (seletor) => {
      const btn = document.querySelector(seletor || '[data-cima-orc]');
      return {
        movimentoReduzidoNoSistema: semMovimento(),
        suporteWebAnimations: typeof Element.prototype.animate === 'function',
        alvoEncontrado: !!document.querySelector('.cima-header__orc .cima-header__fav-icon-wrap'),
        duracao: voaParaOrcamento(btn, true),
      };
    },
  };

  // ── Contador do header ──────────────────────────────────────────────────
  const updateHeader = () => {
    // ⚠️ NÃO zerar o contador quando deslogado (tentei em 27/ago e voltei atrás):
    // a lista continua guardada, e mostrar 0 faz o cliente achar que PERDEU o
    // orçamento dele. Entre "promessa falsa" e "parece que apagou", o segundo é
    // muito pior. O portão de login está no clique e no muro da página.
    const n = read().length;
    const badge = document.getElementById('cima-orc-count');
    const sub = document.getElementById('cima-orc-sub');
    if (badge) {
      badge.textContent = n;
      badge.classList.toggle('cima-header__fav-badge--empty', n === 0);
    }
    if (sub) sub.textContent = n === 1 ? '1 ITEM' : n + ' ITENS';
  };

  // ── Reflete o estado nos botões visíveis ────────────────────────────────
  const reflectButtons = () => {
    const lista = read();
    document.querySelectorAll('[data-cima-orc]').forEach((btn) => {
      const item = lista.find((i) => i.h === String(btn.dataset.productHandle));
      const on = !!item;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      const label = btn.querySelector('[data-orc-label]');
      if (label) {
        label.textContent = on
          ? (btn.dataset.labelOn || 'No orçamento')
          : (btn.dataset.labelOff || 'Adicionar ao orçamento');
      }
      const qtd = btn.querySelector('[data-orc-qtd]');
      if (qtd) {
        const mostra = on && item.q > 1;
        qtd.textContent = mostra ? item.q : '';
        qtd.hidden = !mostra;
      }
    });
  };

  // ── Evento de orçamento pro dataLayer ───────────────────────────────────
  // Um só lugar montando o payload: os dois ramos do clique (leve e "somar")
  // chamam daqui, senão um deles volta a ficar mudo sem ninguém perceber.
  const empurraQuote = (evento, btn, qty, totalItens) => {
    if (!window.dataLayer) return;
    try {
      const bruto = btn.closest('[data-ga-item]');
      const ga = JSON.parse((bruto && bruto.dataset.gaItem) || 'null');
      if (!ga) return;
      const item = { ...ga, quantity: qty };
      // Limpa antes de empurrar: sem isso o GTM mescla o `items` do evento
      // anterior por índice e o relatório sai com item que já saiu da lista.
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: evento,
        ecommerce: {
          currency: 'BRL',
          value: Number(((item.price || 0) * qty).toFixed(2)),
          items: [item],
        },
        quote_items: totalItens,
      });
    } catch {}
  };

  // ── Clique nos botões (delegação: card e PDP) ───────────────────────────
  // O botão NUNCA remove: clicar de novo SOMA quantidade. Remover é só na
  // página do orçamento — e o 2º clique avisa isso, pra ninguém ficar
  // procurando como tirar.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cima-orc]');
    if (!btn) return;
    e.preventDefault();

    // ── Portão de login (27/ago, pedido do dono) ──────────────────────────
    // O orçamento é recurso de cliente identificado, como os favoritos na
    // maioria dos sites. Deslogado, o clique não adiciona: leva pro login e
    // volta pra ESTA página depois (o header expõe a base em CIMA_CLIENTE).
    // ⚠️ Falha ABERTA de propósito: se a flag não veio (header não renderizou,
    // página fora do padrão), a gente NÃO tranca ninguém fora — o pior caso
    // aceitável aqui é alguém usar sem login, não o site ficar inoperante.
    if (window.CIMA_CLIENTE && window.CIMA_CLIENTE.logado === false) {
      // Guarda a INTENÇÃO antes de sair. Sem isto a pessoa loga, volta e o item
      // que ela pediu não está lá — parece que o clique não fez nada.
      // Fica em chave própria (não na lista) pra não "adicionar" quem desistiu
      // do login no meio do caminho.
      try {
        const h = String(btn.dataset.productHandle || '');
        if (h) {
          let q = 1;
          if (btn.dataset.qtyFrom) {
            const inp = document.querySelector(btn.dataset.qtyFrom);
            if (inp) q = clampQty(inp.value);
          }
          const vid = btn.dataset.variantFrom
            ? (document.querySelector(btn.dataset.variantFrom) || {}).value
            : btn.dataset.variantId;
          localStorage.setItem(PEND_KEY, JSON.stringify({ h: h, v: vid, q: q, t: Date.now() }));
        }
      } catch (e) { /* storage cheio/bloqueado: segue pro login sem a intenção */ }
      const base = window.CIMA_CLIENTE.loginBase || '/account/login';
      const volta = encodeURIComponent(location.pathname + location.search);
      location.href = base + '?return_to=' + volta + '&locale=pt-BR&ui_hint=full';
      return;
    }

    const handle = String(btn.dataset.productHandle || '');
    if (!handle) return;

    let qty = 1;
    if (btn.dataset.qtyFrom) {
      const input = document.querySelector(btn.dataset.qtyFrom);
      if (input) qty = clampQty(input.value);
    }
    const variantId = btn.dataset.variantFrom
      ? (document.querySelector(btn.dataset.variantFrom) || {}).value
      : btn.dataset.variantId;

    // ── Modo LEVE (ícone no canto do card/PDP, no lugar do antigo favoritar) ──
    // Alterna igual ao coração: um toque põe, outro tira. Sem voo, sem aviso na
    // tela — o feedback é o ícone virar vermelho e o contador do header pular.
    // Quem quiser quantidade ajusta na página do orçamento.
    if (btn.hasAttribute('data-orc-leve')) {
      const tirando = has(handle);
      if (tirando) {
        remove(handle);
      } else {
        add(handle, variantId, 1);
        anima(btn, 'is-pop', 420);
        anima(document.querySelector('.cima-header__orc .cima-header__fav-icon-wrap'), 'is-land', 620);
      }
      anima(document.getElementById('cima-orc-count'), 'is-bump', 620);
      // 🚨 Este ramo dá `return` antes do push lá embaixo, então o evento TEM que
      // sair aqui. Sem isto o clique no card não gerava NADA no GA4 — falha
      // silenciosa: a lista enchia, o relatório ficava vazio, e nada quebrava
      // na tela pra denunciar. Achado em 27/ago.
      empurraQuote(tirando ? 'remove_from_quote' : 'add_to_quote', btn, 1, read().length);
      return;
    }

    const jaEstava = has(handle);
    const lista = add(handle, variantId, qty);
    const agora = (lista.find((i) => i.h === handle) || {}).q || qty;

    anima(btn, 'is-pop', 420);
    // o contador só salta quando a foto "chega" — a sequência é o que dá leitura
    const voo = voaParaOrcamento(btn);
    setTimeout(() => {
      anima(document.querySelector('.cima-header__orc .cima-header__fav-icon-wrap'), 'is-land', 620);
      anima(document.getElementById('cima-orc-count'), 'is-bump', 620);
    }, Math.max(0, voo - 90));

    // Pediu mais do que tem? O orçamento aceita — quantidade de obra passa do
    // estoque o tempo todo, e essa é a graça da ferramenta. O que não pode é o
    // cliente só descobrir no checkout. O número vem do Liquid (data-estoque);
    // o /products/x.js NÃO devolve inventory_quantity.
    const emEstoque = btn.dataset.estoque === undefined ? null : parseInt(btn.dataset.estoque, 10);
    const passou = emEstoque !== null && !isNaN(emEstoque) && agora > emEstoque;

    toast(
      passou
        ? (emEstoque === 0
            ? `Sem estoque hoje. Deixamos ${agora} un. no orçamento assim mesmo — a gente providencia.`
            : `Você pediu ${agora} un. e temos ${emEstoque} hoje. Deixamos no orçamento assim mesmo — o resto a gente providencia.`)
        : jaEstava
          ? `Agora são ${agora} un. no orçamento. Para remover, use a página do orçamento.`
          : 'Item adicionado ao orçamento. Veja o total ou siga montando a lista da sua obra.',
      [
        { texto: 'Ver orçamento', href: '/pages/orcamento' },
        { texto: 'Continuar adicionando', secundaria: true, fecha: true },
      ]
    );

    empurraQuote('add_to_quote', btn, qty, lista.length);
  });

  // Aviso deixado por outra página antes de navegar (ex.: "Comprar tudo" que
  // adicionou parcialmente e mandou pro /cart) — mostra aqui e some.
  const avisoPendente = () => {
    let bruto = null;
    try { bruto = sessionStorage.getItem('cima:orc:aviso'); sessionStorage.removeItem('cima:orc:aviso'); } catch {}
    if (!bruto) return;
    // aceita texto puro (formato antigo) ou {msg, acao}
    let msg = bruto, acao = null;
    try { const o = JSON.parse(bruto); if (o && o.msg) { msg = o.msg; acao = o.acao || null; } } catch {}
    setTimeout(() => toast(msg, acao ? [acao, { texto: 'Fechar', secundaria: true, fecha: true }] : null), 400);
  };

  // Propriedade de USUÁRIO do GA4: o layout empurra no carregamento, mas a lista
  // muda sem recarregar a página. Sem re-empurrar, quem monta o 1º orçamento
  // seguiria marcado como "nao" até o próximo page_view.
  let ultimoTem = null;
  const syncUsuario = () => {
    const tem = read().length ? 'sim' : 'nao';
    if (tem === ultimoTem || !window.dataLayer) return;
    ultimoTem = tem;
    window.dataLayer.push({ tem_orcamento: tem });
  };

  // ── Item pedido ANTES do login entra assim que a pessoa volta ────────────
  // Roda em qualquer página: o return_to pode não sobreviver ao round-trip do
  // OAuth (a URL do authorize não carrega o parâmetro; ele viaja no `state`),
  // então a intenção não pode depender de cair de volta na página do produto.
  // Descarta intenção velha: voltar dias depois e ganhar um item surpresa é pior
  // do que perder o clique.
  const flushPendente = () => {
    if (window.CIMA_CLIENTE && window.CIMA_CLIENTE.logado === false) return;
    let p = null;
    try { p = JSON.parse(localStorage.getItem(PEND_KEY) || 'null'); } catch (e) { return; }
    if (!p || !p.h) return;
    try { localStorage.removeItem(PEND_KEY); } catch (e) {}
    if (p.t && Date.now() - p.t > 30 * 60 * 1000) return;   // 30 min
    add(p.h, p.v, p.q || 1);
    updateHeader(); reflectButtons();
    toast('Pronto — o item que você escolheu antes de entrar já está no seu orçamento.',
      [{ texto: 'Ver orçamento', href: '/pages/orcamento' },
       { texto: 'Continuar', secundaria: true, fecha: true }]);
  };

  const sync = () => { updateHeader(); reflectButtons(); avisoPendente(); syncUsuario(); flushPendente(); };
  window.addEventListener('storage', (e) => { if (e.key === KEY) sync(); });
  document.addEventListener(EV, sync);

  isolaConta();   // antes do 1º sync(): o item pendente do login precisa cair na lista certa
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  // Conta: puxa ao abrir e ao voltar para a aba (outro aparelho pode ter mexido);
  // ao sair, descarrega o que ainda estiver pendente.
  puxa();
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { if (lsGet(K_SUJO)) empurra(); } else puxa();
  });
  window.addEventListener('pagehide', () => { if (lsGet(K_SUJO)) empurra(); });
})();
